import firebase, { firebaseAnalytics, firebaseRemoteConfig } from './firebase';

export default firebase;
export { firebaseAnalytics, firebaseRemoteConfig };
